import TextContentModelBase from '../_generated/modelBases/text-content-model-base';

export default class TextContentModel extends TextContentModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
